import React, { PropTypes } from 'react';
import { Field, FieldArray, formValueSelector, reduxForm, SubmissionError } from 'redux-form';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import alert from 'alertify.js';
import axios from './../../../constants/axios';
import SelectAsync from './FormHelper/SelectAsyncSaleForm';
import Select from './../../FormTemplate/Select';
import TextareaControl from './../../FormTemplate/TextareaControl';
import RenderInventoryCounterList from './FormHelper/RenderItemList';
import moment from 'moment';
import DateTimePickerControl from './../../FormTemplate/DateTimePickerControl';

class NewSaleForm extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         vendorAddresses: []
      };
   }

   componentWillReceiveProps(nextProps) {
      if (nextProps.contact_id && (typeof nextProps.contact_id === 'number') && nextProps.contact_id !== this.props.contact_id) {
         axios.get(`contacts/${nextProps.contact_id}/getAddresses`)
            .then((res) => {
               let n = res.data.map((add) => {
                  return {
                     value: add.id,
                     label: `${add.address} | ${add.contact_address_type_name}`
                  };
               });
               this.setState({
                  vendorAddresses: n
               });
            });
      }

      if (nextProps.items && nextProps.items.length > 0) {
         nextProps.items.forEach((item) => {
            if (item.price && item.unit) {
               if (item.unit_discount) {
                  item.total = (item.price - item.unit_discount) * item.unit;
                  item.discount_percentage = (item.unit_discount * (100 / item.price)).toFixed(2);
               } else {
                  item.total = item.price * item.unit;
                  item.discount_percentage = 0;
               }
            } else {
               item.total = '';
            }
         });
      }
   }


   submit = (values) => {
      const dataToSend = {
         contact_id: values.contact_id,
         contact_address_id: values.contact_address_id,
         homeDelivery: values.homeDelivery,
         deliveryTime: values.deliveryTime || moment(),
         items: values.items.map((i) => {
            return {
               item_id: i.item_id,
               unit: i.unit,
               price: i.price,
               unit_discount: i.unit_discount || 0,
            };
         })
      };
      if (values.memo) {
         dataToSend.memo = values.memo;
      }
      return axios.post('/inventorySales', dataToSend)
         .then((res) => {
            if (res.status === 201) {
               alert.success('invoice created.');
               this.context.router.push('/sale/saleInvoiceDetail/' + res.data.invoice_id);
            } else {
               alert.error('Something went unexpected. Call Rasel.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw  new SubmissionError(err.response.data);
            } else {
               alert.error('Something not right. Rasel, where are you?');
            }
         });
   };

   render() {
      const { handleSubmit, items, submitting, pristine, invalid, error, homeDelivery } = this.props;
      const totalProductValueAfterDiscount = items ? items.reduce((pre, item) => pre + (item.total), 0) : 0;
      const totalDiscount = items ? items.reduce((pre, item) => pre + (item.unit_discount * item.unit), 0) : 0;
      const totalProductValue = totalProductValueAfterDiscount + totalDiscount;
      const totalNetWeight = items ? items.reduce((pre, item) => pre + ((item.net_weight || 0) * item.unit), 0) : 0;
      // const chargeOnOverWeight = totalNetWeight > 15000 ? ((totalNetWeight - 15000) * .0001) : 0;
      // const deliveryChange = totalProductValueAfterDiscount < 300 ? 20 : 0;
      // const total = homeDelivery ? (totalProductValueAfterDiscount + chargeOnOverWeight + deliveryChange) : totalProductValueAfterDiscount;
      const { vendorAddresses } = this.state;
      return (
         <form noValidate="true"
               autoComplete="off" onSubmit={(e) => this.handleKeyDown(e)} >
            <div className="row" >
               <div className="col-md-6" >
                  <Field name="contact_id" minimumInput={1} component={SelectAsync} link="contacts/searchByName"
                         label="Customer Name" />
               </div >
               <div className="col-md-6" >
                  <div >
                     <label htmlFor="homeDelivery" >Home Delivery</label >{" "}
                     <Field name="homeDelivery" id="homeDelivery" component="input" type="checkbox" />
                  </div >

                  {
                     homeDelivery &&
                     <div >
                        <Field name="contact_address_id" allowEmpty={true} component={Select} options={vendorAddresses}
                               label="Address" />
                     </div >
                  }
                  <Field name="deliveryTime" component={DateTimePickerControl} />
               </div >
            </div >


            <FieldArray items={items} name="items" component={RenderInventoryCounterList} />
            {error && <strong className="input-validation-error" >{error}</strong >}

            <hr />
            <div className="pull-right" >
               <p >Total Weight: {totalNetWeight / 1000} Kg</p >
               <p >Total Value: {totalProductValue}</p >
               <p >Total Discount: {totalDiscount},
                  Percentage: {((totalDiscount * 100) / totalProductValue).toFixed(2)}%</p >
               {/*{homeDelivery && <p >Total Product Value: {totalProductValueAfterDiscount}</p>}*/}
               {/*{homeDelivery && <p >Delivery Charge: {deliveryChange}</p>}*/}
               {/*{homeDelivery && <p >Over Weight Charge: {chargeOnOverWeight}</p>}*/}
               <p >Net Total: {totalProductValueAfterDiscount}</p >
            </div >
            <hr />


            <Field name="memo" label="Memo" component={TextareaControl} />
            <Button type="button" bsStyle="success" block
                    onClick={handleSubmit(this.submit)}
                    disabled={submitting || pristine || invalid} >Save</Button >
         </form >
      );
   }
}

NewSaleForm.propTypes = {
   handleSubmit: PropTypes.func,
   submit: PropTypes.func,
   items: PropTypes.array,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   homeDelivery: PropTypes.bool,
   invalid: PropTypes.bool,
   error: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string
   ]),
   contact_id: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.number
   ])
};

NewSaleForm.contextTypes = {
   router: PropTypes.object
};

NewSaleForm = reduxForm({ // eslint-disable-line
   form: 'newSaleForm'
})(NewSaleForm);

const selector = formValueSelector('newSaleForm');

NewSaleForm = connect(state => { // eslint-disable-line
   const items = selector(state, 'items');
   const contact_id = selector(state, 'contact_id');
   const homeDelivery = selector(state, 'homeDelivery');
   return {
      items,
      contact_id,
      homeDelivery,
   };
})(NewSaleForm);

export default NewSaleForm;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/NewSaleForm.js
 **/